export default __webpack_public_path__ + "67a1c5edeede0847c1be4d2fe4835630.svg";